import React, {useMemo, useState} from "react";
import {makeStyles, TableCell, TableRow} from "@material-ui/core";
import SimpleSelect from "components/SimpleSelect";
import {ContractorVerificationOfferStatus, ContractorVerificationOfferStatusLabel} from "constants/ContractorVerificationOfferStatus";
import PropTypes from "prop-types";
import ContractorVerificationService from "services/ContractorVerificationService";
import Confirm from "components/popup/confirm/Confirm";
import Tr from "translations/Translations";

const useStyles = makeStyles(theme => ({
    statusCell: {
        paddingTop: theme.spacing(),
        paddingBottom: theme.spacing(),
    }
}));

function ContractorVerificationRow(
    {
        index,
        contractorVerificationProcedure,
        contractorElem,
        working,
        editable,
        demandId
    }) {

    const classes = useStyles();
    const [rowWorking, setRowWorking] = useState(false);
    const [confirmOpened, setConfirmOpened] = useState(false);
    const [statusToConfirm, setStatusToConfirm] = useState(null)
    const statusesList = useMemo(()=> Object.keys(ContractorVerificationOfferStatus).filter(x => !!contractorVerificationProcedure.changeable || x !== ContractorVerificationOfferStatus.REVERSE_PROCEDURE).map(key => ({label: ContractorVerificationOfferStatusLabel(key), value: key})), [contractorVerificationProcedure]);

    const updateContractorStatus = (newStatus, confirmed) => {

        if (!confirmed && newStatus === ContractorVerificationOfferStatus.OFFER_REJECTED) {
            setConfirmOpened(true);
            setStatusToConfirm(ContractorVerificationOfferStatus.OFFER_REJECTED);
        } else if (!confirmed && newStatus === ContractorVerificationOfferStatus.NOT_SCORED) {
            setConfirmOpened(true);
            setStatusToConfirm(ContractorVerificationOfferStatus.NOT_SCORED);
        } else {
            setRowWorking(true);
            ContractorVerificationService.updateContractorStatus(demandId, contractorElem.contractor, newStatus).finally(() => setRowWorking(false))
        }
    }

    return (<TableRow>
        <TableCell>{index + 1}.</TableCell>
        <TableCell>{contractorElem.contractor.consorciumOffer ? Tr('consorcium_with_name', {name: contractorElem.contractor.name}) : contractorElem.contractor.name}</TableCell>
        <TableCell className={classes.statusCell}>
            <SimpleSelect
                disabled={!editable || working || rowWorking}
                items={statusesList}
                value={contractorElem.status}
                onChange={(e) => {
                    updateContractorStatus(e.target.value)
                }}
                working={rowWorking}
            />
            {<Confirm confirmText={statusToConfirm === ContractorVerificationOfferStatus.OFFER_REJECTED
                ? 'rfx.scoring.supplier.status.will.change.position.status.confirm'
                : 'rfx.scoring.supplier.status.will.change.position.status.not_scored.confirm'}
                      onCancel={() => setConfirmOpened(false)}
                      onConfirm={() => {
                          setConfirmOpened(false);
                          updateContractorStatus(statusToConfirm, true)
                      }}
                      open={confirmOpened}
                      translateConfirmTexts
            />}
        </TableCell>
    </TableRow>)
}

ContractorVerificationRow.propTypes = {
    index: PropTypes.number,
    contractor: PropTypes.shape({
        contractor: PropTypes.shape({
            identity: PropTypes.number,
            name: PropTypes.string
        }),
        status: PropTypes.string
    }),
    working: PropTypes.bool,
    editable: PropTypes.bool,
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default ContractorVerificationRow;

